webpackJsonp([1],{

/***/ "+DiZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+k33":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Contact","email":"Email","message":"Message","send":"Send"},"tr":{"title":"İletişim","email":"Eposta","message":"Mesaj","send":"Gönder"}}')
}


/***/ }),

/***/ "6uRx":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"waste_label":"Waste","amount_label":"Amount","amount_unit":"tonne/year","waste_list":"Waste List","yearly":"Yearly","daily":"Daily","tonne":"tonne","animal_amount":"Animal Amount","add":"Add","description":"Add your waste information from the form to see production values and proportional evaluation data.","enter_waste_amount":"Enter waste amount","form_description_one":"Please leave your details to see the report prepared for you.","form_description_two":"You can view your report by clicking on the link to your email address.","mail_alert":"The link to access your report has been sent to your email address. Please check your email.","email_address":"Email","name":"Name","phone":"Phone number","send":"Send","production_values":"Production Values","methane_potential":"Methane Potential","year":"Year","electricity_generation":"Electricity Generation","installed_capacity":"Installed Capacity","proportional_evaluation":"Proportional Evaluation","amount_of_waste":"Amount of waste","download_pdf":"Download as pdf"},"tr":{"waste_label":"Atık","amount_label":"Miktar","amount_unit":"ton/yıl","waste_list":"Atık Listesi","yearly":"Yıllık","daily":"Günlük","tonne":"ton","animal_amount":"Hayvan Adedi","add":"Ekle","description":"Üretim değerleri ve oransal değerlendirme verilerini görmek için formdan atık bilgilerinizi ekleyin.","enter_waste_amount":"Atık miktarı girin","form_description_one":"Size özel hazırlanan raporu görmek için lütfen bilgilerinizi bırakın.","form_description_two":"Eposta adresinize gelen linke tıklayarak raporunuzu görebilirsiniz.","mail_alert":"Raporunuza ulaşmanız için gerekli olan link eposta adresinize gönderildi. Lütfen epostanızı kontrol ediniz.","email_address":"Eposta adresiniz","name":"Adınız soyadınız","phone":"Telefon numaranız","send":"Gönder","production_values":"Üretim Değerleri","methane_potential":"Metan Potansiyeli","year":"Yıl","electricity_generation":"Elektrik Üretimi","installed_capacity":"Kurulu Güç","proportional_evaluation":"Oransal Değerlendirme","amount_of_waste":"Atık Miktarı","download_pdf":"PDF olarak indir"}}')
}


/***/ }),

/***/ "7/Yq":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"waste_label":"Waste","amount_label":"Amount","amount_unit":"tonne/year","waste_list":"Waste List","yearly":"Yearly","daily":"Daily","tonne":"tonne","animal_amount":"Animal Amount","add":"Add","description":"Add your waste information from the form to see production values and proportional evaluation data.","enter_waste_amount":"Enter waste amount","form_description_one":"Please leave your details to see the report prepared for you.","form_description_two":"You can view your report by clicking on the link to your email address.","mail_alert":"The link to access your report has been sent to your email address. Please check your email.","email_address":"Email","name":"Name","phone":"Phone number","send":"Send"},"tr":{"waste_label":"Atık","amount_label":"Miktar","amount_unit":"ton/yıl","waste_list":"Atık Listesi","yearly":"Yıllık","daily":"Günlük","tonne":"ton","animal_amount":"Hayvan Adedi","add":"Ekle","description":"Üretim değerleri ve oransal değerlendirme verilerini görmek için formdan atık bilgilerinizi ekleyin.","enter_waste_amount":"Atık miktarı girin","form_description_one":"Size özel hazırlanan raporu görmek için lütfen bilgilerinizi bırakın.","form_description_two":"Eposta adresinize gelen linke tıklayarak raporunuzu görebilirsiniz.","mail_alert":"Raporunuza ulaşmanız için gerekli olan link eposta adresinize gönderildi. Lütfen epostanızı kontrol ediniz.","email_address":"Eposta adresiniz","name":"Adınız soyadınız","phone":"Telefon numaranız","send":"Gönder"}}')
}


/***/ }),

/***/ "8xfZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IJkD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JBcU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/global/app-header/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var app_header = ({
  name: 'AppHeader',
  data: function data() {
    return {
      siteLang: ''
    };
  },
  mounted: function mounted() {
    this.siteLang = this.langDefault;
  },

  watch: {
    siteLang: function siteLang() {
      var payload = {
        lang: this.siteLang,
        app: this
      };
      this.$store.commit('i18n/LANG_CHANGE', payload, { root: true });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])('i18n', ['langDefault', 'langSupport']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c82aafa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/global/app-header/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-header"},[_c('router-link',{staticClass:"logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"static/logo.png"}}),_vm._v(" "),_c('h1',[_vm._v("Biyogaz Hesaplama")])]),_vm._v(" "),_c('div',{staticClass:"select-language"},[_c('img',{attrs:{"src":"static/earth.svg"}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.siteLang),expression:"siteLang"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.siteLang=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.langSupport),function(lang,index){return _c('option',{key:index,attrs:{"val":lang}},[_vm._v(_vm._s(lang))])}),0)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var global_app_header = (esExports);
// CONCATENATED MODULE: ./src/view/global/app-header/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("+DiZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c82aafa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  app_header,
  global_app_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var view_global_app_header = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// EXTERNAL MODULE: ./node_modules/vue-apexcharts/dist/vue-apexcharts.js
var vue_apexcharts = __webpack_require__("HJCm");
var vue_apexcharts_default = /*#__PURE__*/__webpack_require__.n(vue_apexcharts);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/pages/Home/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






vue_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);

/* harmony default export */ var Home = ({
  name: 'Home',
  components: {
    apexcharts: vue_apexcharts_default.a
  },
  data: function data() {
    return {
      wasteList: [],
      selectedWaste: '',
      selectedWasteType: '',
      selectedAmountTimeType: '',
      selectedAmountMassType: '',
      selectedAmount: '',
      selectedAnimalAmount: '',
      userWasteList: [],
      color: '#000000',
      methanePotential: 0,
      electricityGeneration: 0,
      installedCapacity: '',
      email: '',
      name: '',
      phone: '',
      visibleSection: 'description'
    };
  },
  mounted: function mounted() {
    var _this = this;

    var formData = new FormData();

    formData.append('action', 'get_ajax_posts');
    vue_esm["a" /* default */].axios.post('https://pales.com.tr/wp-admin/admin-ajax.php', formData).then(function (response) {
      _this.wasteList = response.data;
    });
  },

  watch: {
    '$route': function $route(to, from) {}
  },
  methods: {
    addWasteToUserWasteList: function addWasteToUserWasteList() {
      var _this2 = this;

      this.generator();
      var item = this.wasteList.find(function (item) {
        return item.atik_id === _this2.selectedWaste;
      });

      if (this.selectedAnimalAmount !== '') {
        item.miktar = this.selectedAnimalAmount * item.atik_uretimi * 365 / 1000;
      } else {
        if (this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Ton') {
          item.miktar = this.selectedAmount;
        } else if (this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Kg') {
          item.miktar = this.selectedAmount * 0.001;
        } else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Ton') {
          item.miktar = this.selectedAmount * 365;
        } else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Kg') {
          item.miktar = this.selectedAmount * 365 / 1000;
        }
      }
      item.color = this.color;
      this.userWasteList.push(item);
      this.visibleSection = 'form';
    },

    generator: function generator(event) {
      this.color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
    },
    removeWaste: function removeWaste(wasteID) {
      this.userWasteList.splice(wasteID, 1);
      this.calculateProductionValues();
    },
    setWasteType: function setWasteType() {
      var animalWasteList = ['66', '67', '68', '69', '70', '71', '72', '73'];
      if (animalWasteList.includes(this.selectedWaste)) {
        this.selectedWasteType = 'Animal';
      } else {
        this.selectedWasteType = 'Other';
      }
    },
    resetOtherAmounts: function resetOtherAmounts() {
      this.selectedAmountTimeType = '';
      this.selectedAmountMassType = '';
      this.selectedAmount = '';
    },
    generateToken: function generateToken(length) {
      var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
      var b = [];
      for (var i = 0; i < length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      return b.join("");
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this3 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          var userToken = _this3.generateToken(32);
          var formData = new FormData();

          var userData = {
            name: _this3.name,
            email: _this3.email,
            phone: _this3.phone,
            token: userToken,
            wasteList: _this3.userWasteList
          };

          formData.append('action', 'send_email');
          formData.append('name', _this3.name);
          formData.append('email', _this3.email);
          formData.append('phone', _this3.phone);
          formData.append('token', userToken);
          formData.append('userData', stringify_default()(userData));

          vue_esm["a" /* default */].axios.post('https://pales.com.tr/wp-admin/admin-ajax.php', formData).then(function (response) {
            _this3.visibleSection = 'mailalert';
            var userData = {
              token: userToken,
              userWasteList: _this3.userWasteList
            };
            localStorage.setItem('userData', stringify_default()(userData));
          });
          return;
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed84e7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/pages/Home/index.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage-wrapper"},[_c('div',{staticClass:"holder"},[_c('div',{staticClass:"panel-left"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('waste_label')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWaste),expression:"selectedWaste"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedWaste=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setWasteType]}},_vm._l((_vm.wasteList),function(waste){return _c('option',{domProps:{"value":waste.atik_id}},[_vm._v(_vm._s(waste.hammadde))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('amount_label')))]),_vm._v(" "),_c('div',{staticClass:"checkbox-holder mb-10"},[_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedAmountType1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountTimeType),expression:"selectedAmountTimeType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedAmountType","id":"selectedAmountType1","value":"Yıllık"},domProps:{"checked":_vm._q(_vm.selectedAmountTimeType,"Yıllık")},on:{"change":[function($event){_vm.selectedAmountTimeType="Yıllık"},function($event){_vm.selectedAnimalAmount = ''}]}}),_vm._v(" "),_c('span'),_vm._v("\n              "+_vm._s(_vm.$t('yearly'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedAmountType2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountTimeType),expression:"selectedAmountTimeType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedAmountType","id":"selectedAmountType2","value":"Günlük"},domProps:{"checked":_vm._q(_vm.selectedAmountTimeType,"Günlük")},on:{"change":[function($event){_vm.selectedAmountTimeType="Günlük"},function($event){_vm.selectedAnimalAmount = ''}]}}),_vm._v(" "),_c('span'),_vm._v("\n              "+_vm._s(_vm.$t('daily'))+"\n            ")])])]),_vm._v(" "),(_vm.selectedAmountTimeType !== '')?_c('div',{staticClass:"checkbox-holder mb-20"},[_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedMassType1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountMassType),expression:"selectedAmountMassType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedMassType","id":"selectedMassType1","value":"Ton"},domProps:{"checked":_vm._q(_vm.selectedAmountMassType,"Ton")},on:{"change":[function($event){_vm.selectedAmountMassType="Ton"},function($event){_vm.selectedAnimalAmount = ''}]}}),_vm._v(" "),_c('span'),_vm._v("\n              "+_vm._s(_vm.$t('tonne'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedMassType2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountMassType),expression:"selectedAmountMassType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedMassType","id":"selectedMassType2","value":"Kg"},domProps:{"checked":_vm._q(_vm.selectedAmountMassType,"Kg")},on:{"change":[function($event){_vm.selectedAmountMassType="Kg"},function($event){_vm.selectedAnimalAmount = ''}]}}),_vm._v(" "),_c('span'),_vm._v("\n              Kg\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.selectedAmountMassType !== '')?_c('div',[_c('p',{staticClass:"label-helper"},[_vm._v(_vm._s(_vm.$t('enter_waste_amount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmount),expression:"selectedAmount"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.selectedAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedAmount=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.selectedWasteType === 'Animal')?_c('div',{staticClass:"mt-20"},[_c('label',[_vm._v(_vm._s(_vm.$t('animal_amount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAnimalAmount),expression:"selectedAnimalAmount"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.selectedAnimalAmount)},on:{"focus":_vm.resetOtherAmounts,"input":function($event){if($event.target.composing){ return; }_vm.selectedAnimalAmount=$event.target.value}}})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-full btn-blue",attrs:{"disabled":_vm.selectedAmount === '' && _vm.selectedAnimalAmount ===''},on:{"click":_vm.addWasteToUserWasteList}},[_vm._v(_vm._s(_vm.$t('add')))]),_vm._v(" "),(_vm.userWasteList.length)?_c('div',{staticClass:"user-waste-list"},[_c('h3',[_vm._v(_vm._s(_vm.$t('waste_list')))]),_vm._v(" "),_c('ul',_vm._l((_vm.userWasteList),function(userWaste,index){return _c('li',{style:({ backgroundColor: userWaste.color})},[_c('span',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(userWaste.hammadde))]),_vm._v(" "),_c('em',[_vm._v(_vm._s(userWaste.miktar)+" "+_vm._s(userWaste.birim_kutle_2)+"/"+_vm._s(userWaste.birim_zaman_2))])]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeWaste(index)}}},[_c('img',{attrs:{"src":"static/close.svg"}})])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content-area"},[(_vm.visibleSection === 'description')?_c('p',{staticClass:"text-center mb-20"},[_vm._v(_vm._s(_vm.$t('description')))]):_vm._e(),_vm._v(" "),(_vm.visibleSection === 'mailalert')?_c('p',{staticClass:"text-center mb-20 alert-success"},[_vm._v(_vm._s(_vm.$t('mail_alert')))]):_vm._e(),_vm._v(" "),(_vm.visibleSection === 'form')?_c('div',{staticClass:"container"},[_c('p',{staticClass:"text-center mb-30"},[_vm._v("\n          "+_vm._s(_vm.$t('form_description_one'))),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$t('form_description_two')))])]),_vm._v(" "),_c('form',{staticClass:"lead-form",on:{"submit":function($event){$event.preventDefault();return _vm.validateBeforeSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('email_address')))]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"form-control",class:{'input': true, 'is-danger': _vm.errors.has('eposta') },attrs:{"name":"eposta","type":"text"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('eposta')),expression:"errors.has('eposta')"}],staticClass:"fa fa-warning"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('eposta')),expression:"errors.has('eposta')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('eposta')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('name')))]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"form-control",class:{'input': true, 'is-danger': _vm.errors.has('isim') },attrs:{"name":"isim","type":"text"},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('isim')),expression:"errors.has('isim')"}],staticClass:"fa fa-warning"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('isim')),expression:"errors.has('isim')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('isim')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('phone')))]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"},{name:"validate",rawName:"v-validate",value:('required|numeric'),expression:"'required|numeric'"}],staticClass:"form-control",class:{'input': true, 'is-danger': _vm.errors.has('telefon') },attrs:{"name":"telefon","type":"text"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('telefon')),expression:"errors.has('telefon')"}],staticClass:"fa fa-warning"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('telefon')),expression:"errors.has('telefon')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('telefon')))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-full btn-blue",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('send')))])])]):_vm._e()])])])}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/view/pages/Home/index.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("JBcU")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__("7/Yq")
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Home_Component)
}


/* harmony default export */ var view_pages_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./src/view/pages/Home/route/index.js


/* harmony default export */ var Home_route = ({
  path: '/',
  name: 'Home',
  component: view_pages_Home,
  meta: {
    main_menu: true
  }
});
// EXTERNAL MODULE: ./node_modules/jspdf/dist/jspdf.min.js
var jspdf_min = __webpack_require__("l9mu");
var jspdf_min_default = /*#__PURE__*/__webpack_require__.n(jspdf_min);

// EXTERNAL MODULE: ./node_modules/html2canvas/dist/html2canvas.js
var html2canvas = __webpack_require__("eMjc");
var html2canvas_default = /*#__PURE__*/__webpack_require__.n(html2canvas);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/pages/About/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








vue_esm["a" /* default */].use(vue_axios_min_default.a, axios_default.a);

/* harmony default export */ var About = ({
  name: 'About',
  components: {
    apexcharts: vue_apexcharts_default.a
  },
  data: function data() {
    return {
      wasteList: [],
      selectedWaste: '',
      selectedWasteType: '',
      selectedAmountTimeType: '',
      selectedAmountMassType: '',
      selectedAmount: '',
      selectedAnimalAmount: '',
      userWasteList: [],
      color: '#000000',
      methanePotential: 0,
      electricityGeneration: 0,
      installedCapacity: '',
      visibleSection: 'form',
      electricityPotentialChartSeries: [{
        data: []
      }],
      wasteAmountChartSeries: [{
        data: []
      }],
      electricityPotentialChartOptions: {
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: false,
            dataLabels: {
              position: 'bottom'
            }
          }
        },
        colors: [],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          formatter: function formatter(val, opt) {
            //return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
            return val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },

        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            show: true
          }
        },
        title: {
          text: 'Elektrik Üretimi (kWh / ton)',
          align: 'center',
          floating: true
        },
        subtitle: {
          text: '',
          align: 'center'
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function formatter() {
                return '';
              }
            }
          }
        }
      },
      wasteAmountChartOptions: {
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: false,
            dataLabels: {
              position: 'bottom'
            }
          }
        },
        colors: [],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          formatter: function formatter(val, opt) {
            //return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
            return val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },

        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            show: true
          }
        },
        title: {
          text: 'Atık Miktarı (ton/yıl)',
          align: 'center',
          floating: true
        },
        subtitle: {
          text: '',
          align: 'center'
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function formatter() {
                return '';
              }
            }
          }
        }
      },
      electricityPotentialPieChartSeries: [],
      electricityPotentialPieChartOptions: {
        labels: [],
        colors: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      wasteAmountPieChartSeries: [],
      wasteAmountPieChartOptions: {
        labels: [],
        colors: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    var formData = new FormData();

    formData.append('action', 'get_ajax_posts');
    vue_esm["a" /* default */].axios.post('http://pales.com.tr/wp-admin/admin-ajax.php', formData).then(function (response) {
      _this.wasteList = response.data;
    });

    var leadFormData = new FormData();
    leadFormData.append('action', 'get_leads');
    vue_esm["a" /* default */].axios.post('http://pales.com.tr/wp-admin/admin-ajax.php', leadFormData).then(function (response) {
      var userToken = _this.$route.params.token;
      var i;
      for (i = 0; i < response.data.length; i++) {
        if (response.data[i].token === userToken) {
          _this.userWasteList = response.data[i].wasteList;
          _this.visibleSection = 'report';
          _this.calculateProductionValues();
        }
      }
    });
  },

  watch: {
    '$route': function $route(to, from) {
      var userData = JSON.parse(localStorage.getItem('userData'));
      if (userData.token === this.$route.params.token) {
        this.visibleSection = 'report';
        this.userWasteList = userData.userWasteList;
        this.calculateProductionValues();
      } else {
        this.$router.push('/');
      }
    }
  },
  methods: {
    addWasteToUserWasteList: function addWasteToUserWasteList() {
      var _this2 = this;

      this.generator();
      var item = this.wasteList.find(function (item) {
        return item.atik_id === _this2.selectedWaste;
      });

      if (this.selectedAnimalAmount !== '') {
        item.miktar = this.selectedAnimalAmount * item.atik_uretimi * 365 / 1000;
      } else {
        if (this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Ton') {
          item.miktar = this.selectedAmount;
        } else if (this.selectedAmountTimeType === 'Yıllık' && this.selectedAmountMassType === 'Kg') {
          item.miktar = this.selectedAmount * 0.001;
        } else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Ton') {
          item.miktar = this.selectedAmount * 365;
        } else if (this.selectedAmountTimeType === 'Günlük' && this.selectedAmountMassType === 'Kg') {
          item.miktar = this.selectedAmount * 365 / 1000;
        }
      }
      item.color = this.color;
      this.userWasteList.push(item);
      this.calculateProductionValues();
    },
    calculateProductionValues: function calculateProductionValues() {
      //console.log(this.userWasteList)
      this.methanePotential = 0;
      this.electricityGeneration = 0;
      var i = void 0;

      // Reset potential chart data
      this.electricityPotentialChartSeries[0].data = [];
      this.electricityPotentialChartOptions.xaxis.categories = [];
      this.electricityPotentialChartOptions.colors = [];
      // -- Pie Chart
      this.electricityPotentialPieChartSeries = [];
      this.electricityPotentialPieChartOptions.labels = [];
      this.electricityPotentialPieChartOptions.colors = [];

      // Reset waste amount chart data
      this.wasteAmountChartSeries[0].data = [];
      this.wasteAmountChartOptions.xaxis.categories = [];
      this.wasteAmountChartOptions.colors = [];
      // -- Pie Chart
      this.wasteAmountPieChartSeries = [];
      this.wasteAmountPieChartOptions.labels = [];
      this.wasteAmountPieChartOptions.colors = [];

      for (i = 0; i < this.userWasteList.length; i++) {
        this.methanePotential += parseFloat(this.userWasteList[i].metan_potansiyeli.replace(',', '.')) * parseFloat(this.userWasteList[i].miktar);
        this.electricityGeneration += parseFloat(this.userWasteList[i].elektrik_potansiyeli.replace(',', '.')) * parseFloat(this.userWasteList[i].miktar);

        // Electricity potential chart data
        var selectedWasteElectricityGeneration = parseFloat(this.userWasteList[i].elektrik_potansiyeli) * parseFloat(this.userWasteList[i].miktar);
        this.electricityPotentialChartSeries[0].data.push(parseFloat(selectedWasteElectricityGeneration));
        this.electricityPotentialChartOptions.xaxis.categories.push(this.userWasteList[i].hammadde);
        this.electricityPotentialChartOptions.colors.push(this.userWasteList[i].color);
        // -- Pie Chart
        this.electricityPotentialPieChartSeries.push(parseFloat(selectedWasteElectricityGeneration));
        this.electricityPotentialPieChartOptions.labels.push(this.userWasteList[i].hammadde);
        this.electricityPotentialPieChartOptions.colors.push(this.userWasteList[i].color);

        // Waste amount chart data
        var selectedWasteAmount = parseFloat(parseFloat(this.userWasteList[i].miktar));
        this.wasteAmountChartSeries[0].data.push(selectedWasteAmount);
        this.wasteAmountChartOptions.xaxis.categories.push(this.userWasteList[i].hammadde);
        this.wasteAmountChartOptions.colors.push(this.userWasteList[i].color);
        // -- Pie Chart
        this.wasteAmountPieChartSeries.push(selectedWasteAmount);
        this.wasteAmountPieChartOptions.labels.push(this.userWasteList[i].hammadde);
        this.wasteAmountPieChartOptions.colors.push(this.userWasteList[i].color);

        this.selectedAmount = '';
        this.selectedAmountTimeType = '';
        this.selectedAmountMassType = '';
        this.selectedWaste = '';
        this.selectedAnimalAmount = '';
      }
      var self = this;
      vue_esm["a" /* default */].nextTick(function () {
        // Update electricity potential chart data
        self.$refs.electrictyPotentialChart.updateOptions({ xaxis: { categories: self.electricityPotentialChartOptions.xaxis.categories } });
        self.$refs.electrictyPotentialChart.updateOptions({ colors: self.electricityPotentialChartOptions.colors });
        // -- Pie Chart
        self.$refs.electrictyPotentialPieChart.updateOptions({ labels: self.electricityPotentialPieChartOptions.labels });
        self.$refs.electrictyPotentialPieChart.updateOptions({ colors: self.electricityPotentialPieChartOptions.colors });

        // Update amount chart data
        self.$refs.wasteAmountChart.updateOptions({ xaxis: { categories: self.wasteAmountChartOptions.xaxis.categories } });
        self.$refs.wasteAmountChart.updateOptions({ colors: self.wasteAmountChartOptions.colors });
        // -- Pie Chart
        self.$refs.wasteAmountPieChart.updateOptions({ labels: self.wasteAmountPieChartOptions.labels });
        self.$refs.wasteAmountPieChart.updateOptions({ colors: self.wasteAmountPieChartOptions.colors });
      });
    },

    generator: function generator(event) {
      this.color = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
    },
    removeWaste: function removeWaste(wasteID) {
      this.userWasteList.splice(wasteID, 1);
      this.calculateProductionValues();
    },
    setWasteType: function setWasteType() {
      var animalWasteList = ['66', '67', '68', '69', '70', '71', '72', '73'];
      if (animalWasteList.includes(this.selectedWaste)) {
        this.selectedWasteType = 'Animal';
      } else {
        this.selectedWasteType = 'Other';
      }
    },
    resetOtherAmounts: function resetOtherAmounts() {
      this.selectedAmountTimeType = '';
      this.selectedAmountMassType = '';
      this.selectedAmount = '';
    },
    generateToken: function generateToken(length) {
      var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
      var b = [];
      for (var i = 0; i < length; i++) {
        var j = (Math.random() * (a.length - 1)).toFixed(0);
        b[i] = a[j];
      }
      return b.join("");
    },
    downloadPDF: function downloadPDF() {
      var reportHeight = this.$refs.reportContent.clientHeight;
      var reportWidth = this.$refs.reportContent.clientWidth;
      var orientation = void 0;
      if (window.screen.width < 678) {
        orientation = 'portrait';
      } else {
        orientation = 'landscape';
      }
      var doc = new jspdf_min_default.a({
        orientation: orientation,
        unit: 'px',
        format: [reportWidth, reportHeight]
      });
      /** WITH CSS */
      var canvasElement = document.createElement('canvas');
      html2canvas_default()(this.$refs.reportContent, {
        canvas: canvasElement,
        scale: 3
      }).then(function (canvas) {
        var img = canvas.toDataURL("image/png");
        doc.addImage(img, 'JPEG', 0, 0, reportWidth / 2, reportHeight / 2);
        doc.save("pales_report.pdf");
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9839b5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/pages/About/index.vue
var About_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"homepage-wrapper"},[_c('div',{staticClass:"holder"},[_c('div',{staticClass:"panel-left"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('waste_label')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWaste),expression:"selectedWaste"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedWaste=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setWasteType]}},_vm._l((_vm.wasteList),function(waste){return _c('option',{domProps:{"value":waste.atik_id}},[_vm._v(_vm._s(waste.hammadde))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$t('amount_label')))]),_vm._v(" "),_c('div',{staticClass:"checkbox-holder mb-10"},[_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedAmountType1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountTimeType),expression:"selectedAmountTimeType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedAmountType","id":"selectedAmountType1","value":"Yıllık"},domProps:{"checked":_vm._q(_vm.selectedAmountTimeType,"Yıllık")},on:{"change":[function($event){_vm.selectedAmountTimeType="Yıllık"},function($event){_vm.selectedAnimalAmount = ''}]}}),_vm._v(" "),_c('span'),_vm._v("\n              "+_vm._s(_vm.$t('yearly'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedAmountType2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountTimeType),expression:"selectedAmountTimeType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedAmountType","id":"selectedAmountType2","value":"Günlük"},domProps:{"checked":_vm._q(_vm.selectedAmountTimeType,"Günlük")},on:{"change":function($event){_vm.selectedAmountTimeType="Günlük"}}}),_vm._v(" "),_c('span'),_vm._v("\n              "+_vm._s(_vm.$t('daily'))+"\n            ")])])]),_vm._v(" "),(_vm.selectedAmountTimeType !== '')?_c('div',{staticClass:"checkbox-holder mb-20"},[_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedMassType1"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountMassType),expression:"selectedAmountMassType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedMassType","id":"selectedMassType1","value":"Ton"},domProps:{"checked":_vm._q(_vm.selectedAmountMassType,"Ton")},on:{"change":function($event){_vm.selectedAmountMassType="Ton"}}}),_vm._v(" "),_c('span'),_vm._v("\n              "+_vm._s(_vm.$t('tonne'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',{attrs:{"for":"selectedMassType2"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmountMassType),expression:"selectedAmountMassType"}],staticClass:"form-control",attrs:{"type":"radio","name":"selectedMassType","id":"selectedMassType2","value":"Kg"},domProps:{"checked":_vm._q(_vm.selectedAmountMassType,"Kg")},on:{"change":function($event){_vm.selectedAmountMassType="Kg"}}}),_vm._v(" "),_c('span'),_vm._v("\n              Kg\n            ")])])]):_vm._e(),_vm._v(" "),(_vm.selectedAmountMassType !== '')?_c('div',[_c('p',{staticClass:"label-helper"},[_vm._v(_vm._s(_vm.$t('enter_waste_amount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAmount),expression:"selectedAmount"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.selectedAmount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedAmount=$event.target.value}}})]):_vm._e(),_vm._v(" "),(_vm.selectedWasteType === 'Animal')?_c('div',{staticClass:"mt-20"},[_c('label',[_vm._v(_vm._s(_vm.$t('animal_amount')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedAnimalAmount),expression:"selectedAnimalAmount"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.selectedAnimalAmount)},on:{"focus":_vm.resetOtherAmounts,"input":function($event){if($event.target.composing){ return; }_vm.selectedAnimalAmount=$event.target.value}}})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-full btn-blue",attrs:{"disabled":_vm.selectedAmount === '' && _vm.selectedAnimalAmount ===''},on:{"click":_vm.addWasteToUserWasteList}},[_vm._v(_vm._s(_vm.$t('add')))]),_vm._v(" "),(_vm.userWasteList.length)?_c('div',{staticClass:"user-waste-list"},[_c('h3',[_vm._v(_vm._s(_vm.$t('waste_list')))]),_vm._v(" "),_c('ul',_vm._l((_vm.userWasteList),function(userWaste,index){return _c('li',{style:({ backgroundColor: userWaste.color})},[_c('span',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(userWaste.hammadde))]),_vm._v(" "),_c('em',[_vm._v(_vm._s(userWaste.miktar)+" "+_vm._s(userWaste.birim_kutle_2)+"/"+_vm._s(userWaste.birim_zaman_2))])]),_vm._v(" "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.removeWaste(index)}}},[_c('img',{attrs:{"src":"static/close.svg"}})])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{ref:"reportContent",staticClass:"content-area"},[(_vm.visibleSection === 'report')?_c('div',{staticClass:"container"},[_c('div',{staticClass:"title-wrapper mb-20"},[_c('h2',[_vm._v(_vm._s(_vm.$t('production_values')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-blue",on:{"click":_vm.downloadPDF}},[_vm._v(_vm._s(_vm.$t('download_pdf')))])]),_vm._v(" "),_c('div',{staticClass:"row mb-40"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"result-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t('methane_potential')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.methanePotential.toFixed(2))+" "),_c('span',[_vm._v("m3 / "+_vm._s(_vm.$t('year')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"result-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t('electricity_generation')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.electricityGeneration.toFixed(2))+" "),_c('span',[_vm._v("kwh / "+_vm._s(_vm.$t('year')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"result-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t('installed_capacity')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.electricityGeneration.toFixed() / 8000)+" "),_c('span',[_vm._v("kwh")])])])])]),_vm._v(" "),_c('h2',{staticClass:"mb-20"},[_vm._v(_vm._s(_vm.$t('proportional_evaluation')))]),_vm._v(" "),_c('div',{staticClass:"row mb-30"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"result-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t('electricity_generation')))]),_vm._v(" "),_c('div',{staticClass:"electricity-potential"},[_c('apexcharts',{ref:"electrictyPotentialChart",attrs:{"width":"100%","height":"350","type":"bar","options":_vm.electricityPotentialChartOptions,"series":_vm.electricityPotentialChartSeries}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"result-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t('amount_of_waste')))]),_vm._v(" "),_c('div',{staticClass:"waste-amount"},[_c('apexcharts',{ref:"wasteAmountChart",attrs:{"width":"100%","height":"350","type":"bar","options":_vm.wasteAmountChartOptions,"series":_vm.wasteAmountChartSeries}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"result-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t('electricity_generation')))]),_vm._v(" "),_c('div',{staticClass:"electricity-potential-pie"},[_c('apexcharts',{ref:"electrictyPotentialPieChart",attrs:{"type":"pie","width":"100%","options":_vm.electricityPotentialPieChartOptions,"series":_vm.electricityPotentialPieChartSeries}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"result-widget"},[_c('h3',[_vm._v(_vm._s(_vm.$t('amount_of_waste')))]),_vm._v(" "),_c('div',{staticClass:"waste-amount-pie"},[_c('apexcharts',{ref:"wasteAmountPieChart",attrs:{"type":"pie","width":"100%","options":_vm.wasteAmountPieChartOptions,"series":_vm.wasteAmountPieChartSeries}})],1)])])])]):_vm._e()])])])}
var About_staticRenderFns = []
var About_esExports = { render: About_render, staticRenderFns: About_staticRenderFns }
/* harmony default export */ var pages_About = (About_esExports);
// CONCATENATED MODULE: ./src/view/pages/About/index.vue
function About_injectStyle (ssrContext) {
  __webpack_require__("8xfZ")
}
var About_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var About___vue_template_functional__ = false
/* styles */
var About___vue_styles__ = About_injectStyle
/* scopeId */
var About___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var About___vue_module_identifier__ = null
var About_Component = About_normalizeComponent(
  About,
  pages_About,
  About___vue_template_functional__,
  About___vue_styles__,
  About___vue_scopeId__,
  About___vue_module_identifier__
)

/* customBlocks */
var About_customBlock = __webpack_require__("6uRx")
if (About_customBlock && About_customBlock.__esModule) {
  About_customBlock = About_customBlock.default
}
if (typeof About_customBlock === "function") {
  About_customBlock(About_Component)
}


/* harmony default export */ var view_pages_About = (About_Component.exports);

// CONCATENATED MODULE: ./src/view/pages/About/route/index.js


/* harmony default export */ var About_route = ({
  path: '/report/:token',
  name: 'About',
  component: view_pages_About,
  meta: {
    main_menu: true
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/pages/Contact/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Contact = ({
  name: 'Contact',
  data: function data() {
    return {
      form: {
        email: '',
        message: ''
      }
    };
  },
  created: function created() {
    this.$store.dispatch('Contact/getMessages');
  },

  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])('Contact', ['messages'])),
  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (!result) return;
        _this.$store.dispatch('Contact/sendMessage', _this.form);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-122641b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/pages/Contact/index.vue
var Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('title')))]),_c('form',{staticClass:"Form",on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('div',{staticClass:"Form-item"},[_c('label',{staticClass:"Form-item-label"},[_vm._v(_vm._s(_vm.$t('email')))]),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"},{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],staticClass:"txt",class:{ 'is-danger': _vm.errors.has('email') },attrs:{"name":"email","data-vv-as":"Eposta","type":"email"},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"Form-item-help is-danger"},[_vm._v(_vm._s(_vm.errors.first('email')))])]),_c('div',{staticClass:"Form-item"},[_c('label',{staticClass:"Form-item-label"},[_vm._v(_vm._s(_vm.$t('message')))]),_c('div',{staticClass:"control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"},{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],staticClass:"txt",class:{ 'is-danger': _vm.errors.has('message') },attrs:{"rows":"3","name":"message","data-vv-as":"Mesaj"},domProps:{"value":(_vm.form.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}})]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('message')),expression:"errors.has('message')"}],staticClass:"Form-item-help is-danger"},[_vm._v(_vm._s(_vm.errors.first('message')))])]),_c('div',{staticClass:"Form-item"},[_c('button',{staticClass:"btn",attrs:{"type":"submit","disabled":_vm.$loading.isLoading('sending message')}},[_vm._v(_vm._s(_vm.$t('send')))])])]),_c('div',{staticClass:"Notes"},[(_vm.$loading.isLoading('loading messages'))?[_c('h5',[_vm._v("Loading...")])]:_vm._l((_vm.messages),function(message){return _c('div',{key:message.id,staticClass:"Item"},[_c('p',{staticClass:"email"},[_vm._v(_vm._s(message.email))]),_c('p',{staticClass:"message"},[_vm._v(_vm._s(message.message))]),_c('time',{staticClass:"date"},[_vm._v(_vm._s(message.humanTime))])])})],2)])}
var Contact_staticRenderFns = []
var Contact_esExports = { render: Contact_render, staticRenderFns: Contact_staticRenderFns }
/* harmony default export */ var pages_Contact = (Contact_esExports);
// CONCATENATED MODULE: ./src/view/pages/Contact/index.vue
function Contact_injectStyle (ssrContext) {
  __webpack_require__("S4Hz")
}
var Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Contact___vue_template_functional__ = false
/* styles */
var Contact___vue_styles__ = Contact_injectStyle
/* scopeId */
var Contact___vue_scopeId__ = "data-v-122641b8"
/* moduleIdentifier (server only) */
var Contact___vue_module_identifier__ = null
var Contact_Component = Contact_normalizeComponent(
  Contact,
  pages_Contact,
  Contact___vue_template_functional__,
  Contact___vue_styles__,
  Contact___vue_scopeId__,
  Contact___vue_module_identifier__
)

/* customBlocks */
var Contact_customBlock = __webpack_require__("+k33")
if (Contact_customBlock && Contact_customBlock.__esModule) {
  Contact_customBlock = Contact_customBlock.default
}
if (typeof Contact_customBlock === "function") {
  Contact_customBlock(Contact_Component)
}


/* harmony default export */ var view_pages_Contact = (Contact_Component.exports);

// CONCATENATED MODULE: ./src/view/pages/Contact/route/index.js


/* harmony default export */ var Contact_route = ({
  path: '/contact',
  name: 'Contact',
  component: view_pages_Contact,
  meta: {
    main_menu: true
  }
});
// CONCATENATED MODULE: ./src/router/index.js



// Pages




vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  routes: [Home_route, About_route, Contact_route]
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__("umy1");
var has_default = /*#__PURE__*/__webpack_require__.n(has);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/global/app-navigation/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var app_navigation = ({
  name: 'AppNavigation',
  computed: {
    mainNav: function mainNav() {
      var nav = src_router.options.routes.filter(function (route) {
        return has_default()(route, 'meta') && route.meta.main_menu;
      });
      nav.forEach(function (item) {
        item.name = item.name.toLocaleLowerCase();
      });
      return nav;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a6b0cc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/global/app-navigation/index.vue
var app_navigation_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppNavigation"},[_c('ul',_vm._l((_vm.mainNav),function(item,index){return _c('router-link',{key:index,attrs:{"tag":"li","to":item.path}},[_c('a',[_vm._v(_vm._s(_vm.$t(item.name)))])])}),1)])}
var app_navigation_staticRenderFns = []
var app_navigation_esExports = { render: app_navigation_render, staticRenderFns: app_navigation_staticRenderFns }
/* harmony default export */ var global_app_navigation = (app_navigation_esExports);
// CONCATENATED MODULE: ./src/view/global/app-navigation/index.vue
function app_navigation_injectStyle (ssrContext) {
  __webpack_require__("cNeX")
}
var app_navigation_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var app_navigation___vue_template_functional__ = false
/* styles */
var app_navigation___vue_styles__ = app_navigation_injectStyle
/* scopeId */
var app_navigation___vue_scopeId__ = "data-v-0a6b0cc8"
/* moduleIdentifier (server only) */
var app_navigation___vue_module_identifier__ = null
var app_navigation_Component = app_navigation_normalizeComponent(
  app_navigation,
  global_app_navigation,
  app_navigation___vue_template_functional__,
  app_navigation___vue_styles__,
  app_navigation___vue_scopeId__,
  app_navigation___vue_module_identifier__
)

/* customBlocks */
var app_navigation_customBlock = __webpack_require__("j1q5")
if (app_navigation_customBlock && app_navigation_customBlock.__esModule) {
  app_navigation_customBlock = app_navigation_customBlock.default
}
if (typeof app_navigation_customBlock === "function") {
  app_navigation_customBlock(app_navigation_Component)
}


/* harmony default export */ var view_global_app_navigation = (app_navigation_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/view/global/app-footer/index.vue

//
//
//
//
//
//
//
//



/* harmony default export */ var app_footer = ({
  name: 'AppFooter',
  data: function data() {
    return {
      siteLang: ''
    };
  },
  mounted: function mounted() {
    this.siteLang = this.langDefault;
  },

  watch: {
    siteLang: function siteLang() {
      var payload = {
        lang: this.siteLang,
        app: this
      };
      this.$store.commit('i18n/LANG_CHANGE', payload, { root: true });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])('i18n', ['langDefault', 'langSupport']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef9b1902","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/global/app-footer/index.vue
var app_footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppFooter"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.siteLang),expression:"siteLang"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.siteLang=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.langSupport),function(lang,index){return _c('option',{key:index,attrs:{"val":lang}},[_vm._v(_vm._s(lang))])}),0)])}
var app_footer_staticRenderFns = []
var app_footer_esExports = { render: app_footer_render, staticRenderFns: app_footer_staticRenderFns }
/* harmony default export */ var global_app_footer = (app_footer_esExports);
// CONCATENATED MODULE: ./src/view/global/app-footer/index.vue
function app_footer_injectStyle (ssrContext) {
  __webpack_require__("SgHs")
}
var app_footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var app_footer___vue_template_functional__ = false
/* styles */
var app_footer___vue_styles__ = app_footer_injectStyle
/* scopeId */
var app_footer___vue_scopeId__ = "data-v-ef9b1902"
/* moduleIdentifier (server only) */
var app_footer___vue_module_identifier__ = null
var app_footer_Component = app_footer_normalizeComponent(
  app_footer,
  global_app_footer,
  app_footer___vue_template_functional__,
  app_footer___vue_styles__,
  app_footer___vue_scopeId__,
  app_footer___vue_module_identifier__
)

/* harmony default export */ var view_global_app_footer = (app_footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//






/* harmony default export */ var App = ({
  name: 'App',
  components: {
    AppHeader: view_global_app_header,
    AppNavigation: view_global_app_navigation,
    AppFooter: view_global_app_footer
  },
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])('i18n', ['langDefault'])),
  mounted: function mounted() {
    var payload = {
      lang: this.langDefault,
      app: this
    };
    this.$store.commit('i18n/LANG_CHANGE', payload, { root: true });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3998432","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App"},[_c('AppHeader'),_c('main',{staticClass:"AppContent"},[_c('router-view')],1)],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("IJkD")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/i18n/index.js



vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

/* harmony default export */ var i18n = (new vue_i18n_esm["a" /* default */]({
  locale: 'tr'
}));
// CONCATENATED MODULE: ./src/i18n/store/index.js
/* harmony default export */ var store = ({
  namespaced: true,
  state: {
    langDefault: localStorage.lang,
    langFallback: 'tr',
    langSupport: ['tr', 'en']
  },
  getters: {
    langDefault: function langDefault(state) {
      if (state.langSupport.indexOf(state.langDefault) === -1) {
        return state.langFallback;
      }
      return state.langDefault;
    },
    langSupport: function langSupport(state) {
      return state.langSupport;
    }
  },
  actions: {},
  mutations: {
    LANG_CHANGE: function LANG_CHANGE(state, _ref) {
      var lang = _ref.lang,
          app = _ref.app;

      state.langDefault = lang;
      localStorage.setItem('lang', lang);
      app.$root.$i18n.locale = lang;
      app.$root.$validator.localize(lang);
    }
  }
});
// CONCATENATED MODULE: ./src/view/pages/Home/store/index.js
// import HTTP from '@/utils/http'

/* harmony default export */ var Home_store = ({
  namespaced: true,
  state: {},
  getters: {},
  actions: {},
  mutations: {}
});
// CONCATENATED MODULE: ./src/view/pages/About/store/index.js
// import HTTP from '@/utils/http'

/* harmony default export */ var About_store = ({
  namespaced: true,
  state: {},
  getters: {},
  actions: {},
  mutations: {}
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./src/utils/http.js


var HTTP = axios_default.a.create({
  baseURL: "http://5a304ec3a871f00012678e6c.mockapi.io/"
});

/* harmony default export */ var http = (HTTP);
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var lodash_findIndex = __webpack_require__("KgVm");
var findIndex_default = /*#__PURE__*/__webpack_require__.n(lodash_findIndex);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// CONCATENATED MODULE: ./src/view/pages/Contact/model/index.js





var model_Messages = function () {
  function Messages() {
    var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    classCallCheck_default()(this, Messages);

    this.list = messages;
  }

  createClass_default()(Messages, [{
    key: 'addMessages',
    value: function addMessages(messages) {
      var _this = this;

      this.list = [];
      messages.forEach(function (message) {
        return _this.addMessage(message);
      });
    }
  }, {
    key: 'addMessage',
    value: function addMessage(message) {
      var newMessage = new model_Message(message);
      this.list.unshift(newMessage);
    }
  }, {
    key: 'deleteMessage',
    value: function deleteMessage(id) {
      var index = this.findIndex(id);
      if (index > -1) {
        this.list.splice(index, 1);
      }
    }
  }, {
    key: 'findIndex',
    value: function findIndex(Id) {
      return findIndex_default()(this.list, ['id', Id]);
    }
  }]);

  return Messages;
}();

/* harmony default export */ var model = (model_Messages);


var model_Message = function () {
  function Message(message) {
    classCallCheck_default()(this, Message);

    this.createdAt = message.createdAt;
    this.email = message.email;
    this.id = message.id;
    this.message = message.message;
  }

  createClass_default()(Message, [{
    key: 'humanTime',
    get: function get() {
      return moment_default.a.unix(this.createdAt).fromNow();
    }
  }]);

  return Message;
}();
// EXTERNAL MODULE: ./node_modules/vuex-loading/dist/vuex-loading.js
var vuex_loading = __webpack_require__("W/lP");
var vuex_loading_default = /*#__PURE__*/__webpack_require__.n(vuex_loading);

// CONCATENATED MODULE: ./src/utils/loader.js


var _createActionHelpers = Object(vuex_loading["createActionHelpers"])({
  moduleName: 'loading'
}),
    startLoading = _createActionHelpers.startLoading,
    endLoading = _createActionHelpers.endLoading;


// CONCATENATED MODULE: ./src/view/pages/Contact/store/index.js






/* harmony default export */ var Contact_store = ({
  namespaced: true,
  state: {
    messages: new model()
  },
  getters: {
    messages: function messages(state) {
      return state.messages.list;
    }
  },
  actions: {
    getMessages: function getMessages(_ref) {
      var _this = this;

      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var RES;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                startLoading(dispatch, 'loading messages');
                _context.next = 4;
                return http.get('contact');

              case 4:
                RES = _context.sent;

                commit('GET_MESSAGES', RES.data);
                return _context.abrupt('return', RES);

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](0);
                throw Error(_context.t0);

              case 12:
                _context.prev = 12;

                endLoading(dispatch, 'loading messages');
                return _context.finish(12);

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 9, 12, 15]]);
      }))();
    },
    sendMessage: function sendMessage(_ref2, newMessage) {
      var _this2 = this;

      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var RES;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                startLoading(dispatch, 'sending message');
                _context2.next = 4;
                return http.post('contact', newMessage);

              case 4:
                RES = _context2.sent;

                commit('SEND_MESSAGE', RES.data);
                return _context2.abrupt('return', RES);

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](0);
                throw Error(_context2.t0);

              case 12:
                _context2.prev = 12;

                endLoading(dispatch, 'sending message');
                return _context2.finish(12);

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 9, 12, 15]]);
      }))();
    }
  },
  mutations: {
    GET_MESSAGES: function GET_MESSAGES(state, data) {
      state.messages.addMessages(data);
    },
    SEND_MESSAGE: function SEND_MESSAGE(state, data) {
      state.messages.addMessage(data);
    }
  }
});
// CONCATENATED MODULE: ./src/store/index.js



// Global


// Pages




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var src_store = (new vuex_esm["a" /* default */].Store({
  modules: {
    i18n: store,
    Home: Home_store,
    About: About_store,
    Contact: Contact_store
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/tr.js
var tr = __webpack_require__("PZKE");
var tr_default = /*#__PURE__*/__webpack_require__.n(tr);

// CONCATENATED MODULE: ./src/main.js









vee_validate_esm["a" /* Validator */].localize('tr', tr_default.a);

var config = {
  events: 'input'
};

vue_esm["a" /* default */].use(vuex_loading_default.a);
vue_esm["a" /* default */].use(vee_validate_esm["b" /* default */], config);
vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: src_router,
  i18n: i18n,
  store: src_store,
  vueLoading: new vuex_loading_default.a({ useVuex: true }),
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "S4Hz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SgHs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cNeX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j1q5":
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"home":"Home","about":"About","contact":"Contact"},"tr":{"home":"Anasayfa","about":"Hakkımda","contact":"İletişim"}}')
}


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0d15a07f5ed9cfca2eb2.js